import {atom, onMount} from 'nanostores';
import {useStore} from '@nanostores/react';
import storage from './storage.js';

// set to false when enabling CookiesDisclaimer
export const $cookiesConsent = atom(true);

onMount($cookiesConsent, ()=>{
    if (localStorage.getItem('sc_cookies_consent'))
        $cookiesConsent.set(true);
});

export const useCookiesConsent = ()=>useStore($cookiesConsent);

export const enableCookiesConsent = ()=>{
    $cookiesConsent.set(true);
    // this is the only place where localStorage should be used directly
    localStorage.setItem('sc_cookies_consent', '1');
    storage.migrateToLocal();
};

export const disableCookiesConsent = ()=>{
    $cookiesConsent.set(false);
    storage.clear();
    storage.set('sc_hide_cookies_disclaimer', true);
};
